"use strict";

function EncryptLogin() {
    if (navigator?.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (p) => {
                document.getElementById("Latitude").value = p.coords.latitude;
                document.getElementById("Longitude").value = p.coords.longitude;
            },
            () => {
                // do nothing if we can't get the lat/long
            }
        );
    }

    document.getElementById("LogonForm").addEventListener("submit", (event) => {
        event.preventDefault();
        EncryptLoginDivert();

        return false;
    });

    // EC-30350: step-up - when the server re-rendered the page asking for a v2 checkbox, render it here
    // and capture the solved token into the hidden field for the next submit.
    const captchaContainer = document.getElementById("CaptchaV2Container");
    if (captchaContainer && typeof ECP !== "undefined" && ECP.Tools) {
        ECP.Tools.CaptchaV2(captchaContainer, (token) => {
            document.getElementById("CaptchaTokenV2").value = token;
        });
    }
}
function EncryptLoginDivert() {
    const usernameElement = document.getElementById("ews-login-username");
    const passwordElement = document.getElementById("ews-login-password");

    let username = usernameElement.value;
    let password = passwordElement.value;

    usernameElement.value = "";
    passwordElement.value = "";

    let support = false;
    let isEmail = false;
    if (username.indexOf("@") > 0) {
        isEmail = true;
    }

    username = username.toLowerCase().trim();

    if (username.indexOf("$", username.length - 1) !== -1) {
        username = username.slice(0, -1);
        support = true;
    }

    username = EC_Fmt.MD5(username);
    password = EC_Fmt.MD5(password);
    if (isEmail) {
        username = `@${username}`;
    }
    if (support) {
        username += "$";
    }

    document.getElementById("Style").value = username;
    document.getElementById("Theme").value = password;

    // EC-30350: verify a human before posting credentials.
    const captchaContainer = document.getElementById("CaptchaV2Container");
    if (captchaContainer) {
        // Step-up mode: wait until the user solves the visible v2 checkbox, then submit.
        if (!document.getElementById("CaptchaTokenV2").value) {
            return;
        }
        document.getElementById("LogonForm").submit();
        return;
    }
    if (typeof ECP !== "undefined" && ECP.Tools) {
        // Normal path: invisible v3 runs with no user interaction.
        ECP.Tools.CaptchaV3("Login", (token) => {
            document.getElementById("CaptchaToken").value = token;
            document.getElementById("LogonForm").submit();
        });
    } else {
        document.getElementById("LogonForm").submit();
    }
}
